import {ParamCodeExporter} from '../Param';
import {ParamPathParam} from '../../../../../../@polygonjs/polygonjs/src/engine/params/ParamPath';

export class ParamParamPathCodeExporter extends ParamCodeExporter<ParamPathParam> {
	// as_code_default_value_string() {
	// 	return `'${this._param.defaultValue()}'`;
	// }

	override add_main() {
		let val = this._param.value.path();
		val = val.replace(/'/g, "\\'");
		const line = this.prefix() + `.set('${val}')`;
		this._lines.push(line);
	}
}
